export const DefaultLayout = ({ children }) => {
  return (
    <div className="default-layout .container">
      <main className="main">{children}</main>
    </div>
  );
};